import { useMemo as O, useCallback as q } from "../../../../../../external/preact/hooks/dist/hooks.module.js";
import { selectionOptionsFor as v } from "./utils.js";
import { listFrom as x } from "../../../../../../utils/collection/main.js";
const j = ({
  filterParam: o,
  filterValues: p,
  filters: n,
  defaultFilters: c,
  updateFilters: m
}) => {
  const S = O(() => x((n == null ? void 0 : n[o]) ?? (c == null ? void 0 : c[o]) ?? ""), [c, n, o]), b = O(() => p && v(p), [p]), k = q(
    ({ target: M }) => {
      m == null || m({ [o]: (M == null ? void 0 : M.value) || "" });
    },
    [m, o]
  );
  return { selection: S, selectionOptions: b, updateSelection: k };
};
export {
  j as default,
  j as useMultiSelectionFilter
};
